import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components';

const spanContent = css`
  color: ${colors.gray.dark};
`;

const alignIcons = css`
  display: flex;
  gap: 10px;

  > svg {
    color: ${colors.gray.dark};
  }
`;

const faceRecognitionIcon = css`
  display: flex;
  align-items: center;

  > svg {
    width: ${icons.size.small};
    height: ${icons.size.small};
    color: ${colors.gray.dark};

    path,
    g {
      fill: ${colors.gray.dark};
    }
  }
`;

const driverInfo = css`
  width: 100%;
  padding: 20px 0px 10px;
  display: flex;
  gap: 13px;
  align-items: center;

  & > :first-child {
    margin-left: 30px;
  }
  > button {
    margin-left: auto;
    margin-right: 25px;
  }
`;

export default {
  spanContent,
  alignIcons,
  driverInfo,
  faceRecognitionIcon,
};
